import { ITopProductProps } from '../../topProduct.models';
import { useDeviceType } from '@vfit/shared/hooks';
import { TopNavigationLiteHero } from './components/TopNavigationLiteHero/topNavigationLiteHero';
import { TopNavigationLiteCard } from './components/TopNavigationLiteCard/topNavigationLiteCard';
import { CustomText } from '@vfit/shared/atoms';
import { fonts } from '@vfit/shared/themes';
import { Fade } from 'react-awesome-reveal';
import { DisclaimerLiteContainer } from './topNavigationLite.style';

const TopNavigationLite = (props: ITopProductProps) => {
  const { disclaimer } = props || {};
  const { isDesktop, isTablet, isMobile } = useDeviceType();

  return (
    <>
      {isDesktop && <TopNavigationLiteHero {...props} />}
      {(isMobile || isTablet) && <TopNavigationLiteCard {...props} />}
      <Fade direction="up" triggerOnce>
        {disclaimer && (
          <DisclaimerLiteContainer>
            <CustomText
              textAlign="left"
              text={disclaimer}
              lineHeight={22}
              size={16}
              fontFamily={fonts.regular}
            />
          </DisclaimerLiteContainer>
        )}
      </Fade>
    </>
  );
};
export default TopNavigationLite;
